define([
  'react',
  'react-dom',
  'react-redux',
  'es6!launcher/stores/AppStore',
  'jsx!launcher/views/listbuilder/wysiwyg/Popup',
], (React, ReactDOM, ReactRedux, AppStore, Popup) => {
  class ListBuilderPopupStep {
    constructor(popup, settings, step) {
      this.popup = popup;
      this.popupJsonSettings = settings;
    }

    getComponent(name) {
      return this.getComponents().filter((c) => c.get('name') === name).first();
    }

    getComponents() {
      return this.popupJsonSettings.get('components');
    }

    render(container, formValues, formErrors, options = {}) {
      const {
        currentAnimation,
        settings,
        service,
        currentStep,
      } = this.popup;
      const { api } = service;
      // Can't render into undefined or null container.
      if (!container) return;

      // Turn top level object into js but leave the rest immutable data types.
      const popupJson = {
        ...this.popupJsonSettings.toObject(),
        ...options,
      };

      const { Provider } = ReactRedux;

      ReactDOM.render((
        <Provider store={AppStore.get()}>
          <Popup
            fullscreen
            {...popupJson}
            popupId={settings.get('popup_id')}
            container={container}
            formType={settings.get('form_type')}
            advancedForm={settings.get('advanced_form')}
            goal={settings.get('goal')}
            currentStep={currentStep}
            api={api}
            size={settings.get('content_width')}
            animation={currentAnimation}
            defaultFormValues={formValues}
            formErrors={formErrors}
            onChangeForm={this.popup.onChangeForm}
            onClickAction={this.popup.onClickAction}
            onEnterSubmit={this.popup.onEnterSubmit}
            onChangeSize={this.popup.onChangeSize}
            onClickPoweredByVariant={this.popup.onClickPoweredByVariant}
            discount={settings.get('discount')}

            /* Scroll Box Props */
            showPosition={settings.get('show_position')}
            slideDirection={settings.get('slide_direction')}
            /* Smart Bar Props */
            position={settings.get('position')}
            showType={settings.get('show_type')}
            barSize={settings.get('bar_size')}
            /* Welcome Mat Props */
            displayMode={settings.get('display_mode')}
            /* Social Proof Props */
            popupDisplayTime={settings.get('popup_display_time')}
          />
        </Provider>
      ), container);
    }
  }

  return ListBuilderPopupStep;
});
